import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import defaultBGPic from '../images/bg.png';
import IntroVideo from '../Profile/Right Profile/IntroVideo';
import Following from '../Profile/Right Profile/Following';
import Followers from '../Profile/Right Profile/Followers';
import toast from 'react-hot-toast';
import userPic from '../images/user.png';
import UpcomingEvents from '../Landing/Profileandevents/UpcomingEvents';
import './PublicProfile.css';
import { followUnfollowUser } from '../../api/follow-unfollow';
// import { createChat, userChats } from '../../api/chatRequest';
import { getFollowers} from '../../api/userRequest';
import allTag from '../images/allTag.png';
import societytag from '../images/member.png';
import mentortag from '../images/mentor tag.png'

const PublicProfileHeader = ({ userDetails, userData }) => {
  const navigate = useNavigate();
  //   const [userDetails, setUserDetails] = useState(null);
  const [showIntroVideo, setShowIntroVideo] = useState(false);
  const [showFollowers, setShowFollowers] = useState(false);
  const [showFollowings, setShowFollowings] = useState(false);
  const [updateDOM, setUpdateDOM] = useState(false);
  const [showFollowBtn, setShowFollowBtn] = useState(true);
  // const [chat_id, setChatId] = useState('');

  const onClose = () => {
    setShowIntroVideo(false);
  };
  // const getChats = async () => {
  //   try {
  //     const { data } = await userChats(userDetails._id);
  //     const id = data.filter((item) => item.members[0] === userId)[0]._id;
  //     // setChatId(id);
  //   } catch (error) {
  //     toast.error(error.message || "An error occurred while fetching chats");
  //   }
    
  // };
  // const creatingChat = async () => {
  //   try {
  //     const req = {
  //       senderId: userData._id,
  //       receiverId: userId,
  //     };
  //     const { data } = await createChat(req);
  //     // setChatId(data._id);
  //   } catch (error) {
  //     toast.error('chat already exists');
  //   }
  // };
  const userId = window.location.pathname.split('/')[2];
  const handleFollowBtn = async () => {
    try {
      await followUnfollowUser(userId);
      setUpdateDOM(!updateDOM);
      // toast.success('You followed');
      // creatingChat();
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  useEffect(() => {
  const checkFollow = async () => {
    const res = await getFollowers(userId);
    const isFollowing = res.data.result.some(
      (item) => item._id === userData._id
    );
    setShowFollowBtn(!isFollowing);
  };

  // const getChats = async () => {
  //   try {
  //     const { data } = await userChats(userDetails._id);
  //     const chat = data.find(
  //       (item) => item.members.includes(userData._id)
  //     );
  //     if (chat) setChatId(chat._id);
  //   } catch (error) {
  //     toast.error(error.message || 'Error fetching chats');
  //   }
  // };

  if (userId && userData?._id && userDetails?._id) {
    checkFollow();
    // getChats();
  }
}, [userId, userData._id, userDetails?._id, updateDOM]);


  return (
    <>
      <UpcomingEvents />
      <div className='ph-container'>
        <div
          className='ph-bg'
          style={{
            backgroundImage:
              userDetails &&
              (userDetails.bgPicUrl
                ? `url(${userDetails.bgPicUrl})`
                : `url(${defaultBGPic})`),
          }}
        >
          {/* <img src="/bg.png" alt="bg" /> */}
        </div>
        {userDetails && userDetails.introVideo ? (
          <div className='ph-pic-pub'>
            <img
              onClick={() => setShowIntroVideo(true)}
              src={
                userDetails &&
                (userDetails.profilePicUrl
                  ? userDetails.profilePicUrl
                  : userPic)
              }
              alt='user pic'
              style={{ borderRadius: '100%' }}
            />
          </div>
        ) : (
          <img
            className='ph-pic-pub2'
            onClick={() => setShowIntroVideo(true)}
            src={
              userDetails &&
              (userDetails.profilePicUrl ? userDetails.profilePicUrl : userPic)
            }
            alt='user pic'
          />
        )}
        <div className='ph-details'>
          <div className='ph-name'>
            {userDetails.firstname
              ? userDetails.firstname + ' ' + userDetails.lastname
              : 'Loading...'}
            {userDetails && userDetails.isMentor && userDetails.isSocietyMember && (
              <div className='verified-logo'>
                <img src={allTag} width={23} alt='' />
              </div>
            )}
            {userDetails && !userDetails.isMentor && userDetails.isSocietyMember && (
              <div className='verified-logo'>
                <img src={societytag} width={23} alt='' />
              </div>
            )}
            {userDetails && userDetails.isMentor && !userDetails.isSocietyMember && (
              <div className='verified-logo'>
                <img src={mentortag} width={23} alt='' />
              </div>
            )}
          </div>
          {userDetails &&
          userDetails.experence &&
          userDetails.experence.length > 0 ? (
            <p>
              {userDetails.experence[0].title +
                ' @ ' +
                userDetails.experence[0].company}
            </p>
          ) : (
            <p>
              {'Student' +
                (userDetails &&
                  userDetails.experence &&
                  userDetails.education.length > 0 &&
                  ' @ ' + userDetails.education[0].institution)}
            </p>
          )}
          <div className='ph-headline'>
            {userDetails.isMentor && (
              <button
                id='bookSlot'
                onClick={() => {
                  navigate(`/bookslot/${userDetails.mentor._id}`);
                }}
              >
                Book Slot
              </button>
            )}
            {showFollowBtn ? (
              <button
                onClick={handleFollowBtn}
                className='bg-blue-400 px-3 py-1 text-white rounded-full hover:bg-blue-500'
              >
                Follow
              </button>
            ) : (
              <div className='flex gap-5'>
                <button
                  onClick={handleFollowBtn}
                  className='bg-blue-400 px-3 py-1 text-white rounded-full hover:bg-blue-500'
                >
                  Unfollow
                </button>
                <Link to={'/chat'}>
                  <img
                    src='/chat3.png'
                    className='cursor-pointer hover:opacity-80'
                    width={35}
                    alt=''
                  />
                </Link>
                <Link to={`/userposts/${userId}`}>
                  <img
                    src='/post2.png'
                    className='cursor-pointer hover:opacity-80'
                    width={35}
                    alt=''
                  />
                </Link>
              </div>
            )}
          </div>
          <div className='ph-follow'>
            <div
              className='ph-follwers'
              onClick={() => setShowFollowers(!showFollowers)}
            >
              <b>
                {' '}
                {userDetails &&
                  userDetails.followers &&
                  userDetails.followers.length}
              </b>{' '}
              Followers
            </div>
            <div
              className='ph-followings'
              onClick={() => setShowFollowings(!showFollowings)}
            >
              <b>
                {' '}
                {userDetails &&
                  userDetails.followings &&
                  userDetails.followings.length}
              </b>{' '}
              Followings
            </div>
          </div>
          <div className='ph-linkedin'>
            <img src='/linkedin.png' alt='' />
            <p>
              {' '}
              <a
                href={
                  userDetails &&
                  (userDetails.linkedinId &&
                  userDetails.linkedinId.toString().includes('linkedin.com')
                    ? userDetails.linkedinId
                    : `https://linkedin.com/in/${userDetails.linkedinId}`)
                }
                target='_blank'
                rel='noreferrer'
              >
                {userDetails &&
                  (userDetails.linkedinId &&
                  userDetails.linkedinId.toString().includes('linkedin.com')
                    ? userDetails.linkedinId
                    : `https://linkedin.com/in/${userDetails.linkedinId}`)}
              </a>
            </p>
            {showFollowers && userDetails && (
              <Followers
                userid={userDetails._id}
                onClose={() => {
                  setShowFollowers(!showFollowers);
                }}
              />
            )}
            {showFollowings && userDetails && (
              <Following
                userid={userDetails._id}
                onClose={() => {
                  setShowFollowings(!showFollowings);
                }}
              />
            )}
            {showIntroVideo && (
              <IntroVideo
                onClose={onClose}
                introVideoUrl={userDetails.introVideo}
                publicView={true}
              />
            )}
          </div>
          
        </div>
      </div>
    </>
  );
};

export default PublicProfileHeader;
